// *******************************************************************************
// 1.0 - Search toggle
// *******************************************************************************
const headerSearch = document.querySelector('.header-search');

if (headerSearch) {
  const searchInput = document.querySelector('.header-search__input-field');
  const searchResult = headerSearch.querySelector('.header-search__result');

  const toggleSearchResultClass = (toggle) => {
    searchResult.classList.toggle('is-active', toggle);
  };

  // ------
  // Open search
  // ------

  attachEvent('.header-main__search-btn', 'click', (ev) => {
    const isOpen = document.body.classList.contains('is-open-search');
    toggleSearchClass(!isOpen);
    toggleMenuClass(false);
    setTimeout(() => {
      searchInput.focus();
    }, 50);
    ev.preventDefault();
  });

  // ------
  // Close search
  // ------

  attachEvent('.header-search__close, .menu-overlay', 'click', (ev) => {
    searchInput.blur();
    toggleSearchClass(false);
    toggleSearchResultClass(false);
    ev.preventDefault();
  });

  // ------
  // Close Header Search When Escape Key Press
  // ------

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      toggleSearchClass(false);
      toggleSearchResultClass(false);
      searchInput.blur();
    }
  });
}
